export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";

export const SOCIAL_LOGIN = "SOCIAL_LOGIN";

// CUSTOM
export const POST_LOGIN = "POST_LOGIN";
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_FAIL = "POST_LOGIN_FAIL";

export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAIL = "VERIFY_OTP_FAIL";

export const ADMIN_VERIFY_OTP = "ADMIN_VERIFY_OTP";
export const ADMIN_VERIFY_OTP_SUCCESS = "ADMIN_VERIFY_OTP_SUCCESS";
export const ADMIN_VERIFY_OTP_FAIL = "ADMIN_VERIFY_OTP_FAIL";

export const EMP_VERIFY_OTP = "EMP_VERIFY_OTP";
export const EMP_VERIFY_OTP_SUCCESS = "EMP_VERIFY_OTP_SUCCESS";
export const EMP_VERIFY_OTP_FAIL = "EMP_VERIFY_OTP_FAIL";

export const EMPLOYEE_LOGIN = "EMPLOYEE_LOGIN";
export const EMPLOYEE_LOGIN_SUCCESS = "EMPLOYEE_LOGIN_SUCCESS";
export const EMPLOYEE_LOGIN_FAIL = "EMPLOYEE_LOGIN_FAIL";

export const RESEND_OTP = "RESEND_OTP";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAIL = "RESEND_OTP_FAIL";

export const ADMIN_RESEND_OTP = "ADMIN_RESEND_OTP";
export const ADMIN_RESEND_OTP_SUCCESS = "ADMIN_RESEND_OTP_SUCCESS";
export const ADMIN_RESEND_OTP_FAIL = "ADMIN_RESEND_OTP_FAIL";

export const REPORT_LOGIN = "REPORT_LOGIN";
export const REPORT_LOGIN_SUCCESS = "REPORT_LOGIN_SUCCESS";
export const REPORT_LOGIN_FAIL = "REPORT_LOGIN_FAIL";

export const SUPER_ADMIN_LOGIN = "SUPER_ADMIN_LOGIN";
export const SUPER_ADMIN_LOGIN_SUCCESS = "SUPER_ADMIN_LOGIN_SUCCESS";
export const SUPER_ADMIN_LOGIN_FAIL = "SUPER_ADMIN_LOGIN_FAIL";
